/* import __COLOCATED_TEMPLATE__ from './main.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { computed, action } from '@ember/object';

export default Component.extend({
  itemsForDropdown: computed('settings.availableAttributes', function () {
    let items = this.get('settings.availableAttributes').map((item) => ({
      text: item.get('name'),
      value: item,
    }));

    return [
      {
        isFilterable: true,
        items,
      },
    ];
  }),

  addToSelectedAttributes: action(function (item) {
    item.set('selected', true);
  }),
});
